
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
@Component
export default class LoadingModal extends Vue {
  @State("loadingDialog") loadingStatus: any;
}
